/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/guiJjtuScholars/guiJjtuScholarsActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { GuiJjtuScholarEditForm } from "./GuiJjtuScholarEditForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { KTUtil } from "../../../../../../_metronic/_assets/js/components/util";
import KTLayoutQuickForm from "../../../../Admin/utils/quick-form";
import {GuideProfile} from "../../profile/GuideProfile"
import axios from "axios";

const initGuiJjtuScholar = {
  id: undefined,
  guideId: 0,
  scholarId: 0,
  allocationDate: "2020-10-19T12:17:40.994Z",
  remark: "",
  
};
export function GuiJjtuScholarEdit({
  history,
  match: {
    params: { id,gid },
  },
}) {
  useLayoutEffect(() => {
    KTUtil.ready(function() {
      KTLayoutQuickForm.init("kt_quick_form");
    });
  }, []);
  // Subheader
  const subheader = useSubheader();

  // Tabs
  // const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, guiJjtuScholarForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.guiJjtuScholars.actionsLoading,
      guiJjtuScholarForEdit: state.guiJjtuScholars.guiJjtuScholarForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchGuiJjtuScholar(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New Guide JjtuScholar";
    if (guiJjtuScholarForEdit && id) {
      _title = `Edit Guide JjtuScholar`;
    }

    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guiJjtuScholarForEdit, id]);

  const saveGuiJjtuScholar = (values) => {
    if (!id) {
      dispatch(actions.createGuiJjtuScholar(values)).then(() =>
        backToGuiJjtuScholarsList()
      );
    } else {
      dispatch(actions.updateGuiJjtuScholar(values)).then(() =>
        backToGuiJjtuScholarsList()
      );
    }
  };

  const btnRef = useRef();
  const saveGuiJjtuScholarClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const id1 = id===undefined?'':id
  const GuideUrl = `${process.env.REACT_APP_API_URL}/api/GuiJjtuScholar/${id1}`;

  const [guide, setGuide] = useState([]);

  useEffect(() => {
    const getGuide = async () => {
      const response = await axios.get(GuideUrl);
      setGuide(response.data);
    };
    getGuide();
  }, [setGuide,GuideUrl]);


  const GuideId = gid?gid:guide.guideId;
 
 
 
  initGuiJjtuScholar.guideId=GuideId;

  console.log(GuideId)
  const backToGuiJjtuScholarsList = () => {
    history.push(`/guide/guideprofile`);
  };

  return (
    <div>
      <GuideProfile />
      <div
        id="kt_quick_form"
        className="offcanvas offcanvas-right offcanvas offcanvas-on offcanvas-sm"
      >
        <div className="offcanvas-content pr-5 mr-n5">
          <Card>
            {actionsLoading && <ModalProgressBar />}
            <CardHeader title={title}>
              <CardHeaderToolbar>
                <button
                  type="button"
                  onClick={backToGuiJjtuScholarsList}
                  className="btn btn-light"
                >
                  <i className="fa fa-times"></i>
                  Close
                </button>
                {/* <button className="btn btn-light ml-2">
                    <i className="fa fa-redo"></i>
                    Reset
                  </button> */}
                <button
                  type="submit"
                  className="btn btn-primary ml-2"
                  onClick={saveGuiJjtuScholarClick}
                >
                  Save
                </button>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
            {!actionsLoading && (
              <GuiJjtuScholarEditForm
                actionsLoading={actionsLoading}
                guiJjtuScholar={guiJjtuScholarForEdit || initGuiJjtuScholar}
                btnRef={btnRef}
                saveGuiJjtuScholar={saveGuiJjtuScholar}
                />
                )}
            </CardBody>
          </Card>
        </div>
      </div></div>
  );
}
